import { useQuery } from "react-query";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const useGetList = (
  schoolId,
  trainingId,
  accessToken,
  page = 1,
  pageSize = 30,
  filter
) => {
  return useQuery(
    ["payments", schoolId, trainingId, accessToken, page, pageSize, filter],
    async () => {
      let contractId = filter?.contract_id ?? "";
      let method = filter?.method ?? "";
      let status = filter?.status ?? "";
      let sort = filter?.sort ?? "";
      try {
        const response = await fetch(
          BACKEND_URL +
          `/api/v1/schools/${schoolId}/trainings/${trainingId}/payments?contract_id=${contractId}&method=${method}&status=${status}&sort=${sort}&page=${page}&pageSize=${pageSize}`,
          {
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + accessToken,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch payments!");
        }
        if (response.status >= 299) {
          throw new Error("Erreur de récupération de la liste des paiements!");
        }
        const result = await response.json();
        return result;
      } catch (error) {
        // Handle the error
        console.error("Error fetching payments:", error);
        throw error;
      }
    }
  );
};

const GetOne = (schoolId, trainingId, accessToken, paymentId) => {
  return useQuery(
    ["payment", schoolId, trainingId, accessToken, paymentId],
    async () => {
      try {
        const response = await fetch(
          BACKEND_URL +
          `/api/v1/schools/${schoolId}/trainings/${trainingId}/payments/${paymentId}`,
          {
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + accessToken,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Erreur de récupération du paiement!");
        }
        const result = await response.json();
        return result;
      } catch (error) {
        throw error;
      }
    }
  );
};

const CreateOne = async (schoolId, trainingId, accessToken, data) => {
  try {
    const response = await fetch(
      BACKEND_URL +
      "/api/v1/schools/" +
      schoolId +
      "/trainings/" +
      trainingId +
      "/payments",
      {
        method: "POST",
        body: JSON.stringify(data),
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      }
    );
    if (!response.ok) {
      throw new Error(`Erreur de création du paiement!`);
    }
    let actualData = await response.json();
    return actualData;
  } catch (err) {
    throw err;
  }
};

const UpdateOne = async (schoolId, trainingId, accessToken, paymentId, data) => {
  try {
    const response = await fetch(
      BACKEND_URL +
      "/api/v1/schools/" +
      schoolId +
      "/trainings/" +
      trainingId +
      "/payments/" +
      paymentId,
      {
        method: "PATCH",
        body: JSON.stringify(data),
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      }
    );
    if (!response.ok) {
      throw new Error(`Erreur de modification du paiement!`);
    }
    let actualData = await response.json();
    return actualData;
  } catch (err) {
    throw err;
  }
};

const DeleteOne = async (schoolId, trainingId, accessToken, paymentId) => {
  try {
    const response = await fetch(
      BACKEND_URL +
      "/api/v1/schools/" +
      schoolId +
      "/trainings/" +
      trainingId +
      "/payments/" +
      paymentId,
      {
        method: "DELETE",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      }
    );
    if (!response.ok) {
      throw new Error(`Erreur de suppression du paiement!`);
    }
    let actualData = await response.json();
    return actualData;
  } catch (err) {
    throw err;
  }
};

const paymentsAPI = {
  useGetList,
  GetOne,
  CreateOne,
  UpdateOne,
  DeleteOne,
};

export default paymentsAPI;
